import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { BankConnection, ConnectBankBody } from '@klopotun/contracts';
import { connectBank } from '../requests/connect-bank.js';
import { refreshBankAndCards } from './bank-cache.js';

export const useConnectBankMutation = (): UseMutationResult<
  BankConnection,
  Error,
  ConnectBankBody
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectBank,
    onSuccess: () => refreshBankAndCards(queryClient),
  });
};
